import { render, staticRenderFns } from "./tallbutton.vue?vue&type=template&id=4b40e9fe&"
import script from "./tallbutton.vue?vue&type=script&lang=js&"
export * from "./tallbutton.vue?vue&type=script&lang=js&"
import style0 from "./tallbutton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports